module.exports = __webpack_public_path__ + "img/collection-memoireRings.aca351b.webp";